<template>
	<nav class="navbar is-transparent">

	</nav>
</template>
<script>
/* eslint-disable */
export default {
  name: "Navbar",
  computed: {
    stateLocation () {
      return this.$store.state.location
    }
  },
  methods: {

  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue